import { toTwoDecimals } from 'utils';

import { Grid, ListItem, Typography } from '@mui/material';

import { BalanceDto } from 'api/ledger-client'; // Corrected import path

export const BalanceReportItem = ({
  balance,
}: {
  balance: BalanceDto;
}) => {
  return (
    <ListItem divider disableGutters>
      <Grid container>
        <Grid item xs={6}>
          <Typography variant="subtitle1">{balance.currency}</Typography>
        </Grid>
        <Grid item xs={6}>
          <span style={{ marginLeft: '.8rem' }}>
            {toTwoDecimals(balance.amount ?? 0)}
          </span>
        </Grid>
      </Grid>
    </ListItem>
  );
};
